import assert from 'assert-ts';
import type {Schemas} from 'domainTypes/dto';
import type {NorafUpdatesIgnoreListItem} from '../types';

export const mapNorafUpdatesIgnoreList = (
  dto: Schemas.NorafUpdatesIgnoreListResponse,
): NorafUpdatesIgnoreListItem[] => {
  return dto.items.map(mapNorafUpdatesIgnoreListItem);
};

export const mapNorafUpdatesIgnoreListItem = (
  dto: Schemas.NorafUpdatesIgnoreListItem,
): NorafUpdatesIgnoreListItem => {
  return {
    ...dto,
    id: assert(dto.id, 'mapNorafUpdatesIgnoreListItem: Expected id', dto),
  };
};
